import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { SnackbarOpen } from '../actions';
import {
  ADD_ADDRESS,
  AddEditAddressFail,
  EDIT_ADDRESS,
  LOAD_ADDRESSES,
  LoadAddresses,
  LoadAddressesSuccess,
  REMOVE_ADDRESSES,
  LoadFilteredAddressesSuccess,
  RemoveAddressFail,
  SET_ACTIVE_ADDRESS_SEARCH
} from "@store/actions";
import {ActionWithPayload, AppState} from "@store/reducers";
import {UserService} from "@services/user.service";
import {Router} from "@angular/router";
import {Store} from "@ngrx/store";
import {forkJoin} from "rxjs/observable/forkJoin";
import 'rxjs/add/operator/map';

@Injectable()
export class AddressesEffects {
  constructor(
    private actions$: Actions,
    private userService: UserService,
    private router: Router,
    private store: Store<AppState>,
  ) {}

  @Effect() addEditAddress: Observable<any> = this.actions$
    .ofType(ADD_ADDRESS, EDIT_ADDRESS)
    .switchMap((action: ActionWithPayload<any>) => {
      const observable = action.payload.id ? this.userService.editAddressBook(action.payload) :
        this.userService.addAddressBook(action.payload);
      return observable
        .map(() => {
          this.router.navigate(['/address-book']);
          return new SnackbarOpen({
            data: {
              message: 'Address was successfully saved.',
              error: false,
            },
          })
        })
        .catch(() => {
          this.store.dispatch(new SnackbarOpen({
            data: {
              message: 'Address could not be saved.',
              error: true,
            },
          }));
          return Observable.of(new AddEditAddressFail());
        })
    });

  @Effect() removeAddresses = this.actions$
    .ofType(REMOVE_ADDRESSES)
    .switchMap((action: ActionWithPayload<any>) => {
      return forkJoin(action.payload.ids.map((id => this.userService.removeAddressBook(id))))
        .map(() => {
          return new SnackbarOpen({
            data: {
              message: 'Address was successfully deleted.',
              error: false,
            },
          })
        })
        .catch(() => {
          this.store.dispatch(new SnackbarOpen({
            data: {
              message: 'Address could not be deleted.',
              error: true,
            },
          }));
          return Observable.of(new RemoveAddressFail());
        }).finally(() => {
            this.store.dispatch(new LoadAddresses({
              current_page_size: action.payload.current_page_size,
              current_page: action.payload.current_page,
            }));
        });
    });

  @Effect() loadAddresses = this.actions$
    .ofType(LOAD_ADDRESSES)
    .switchMap((action: ActionWithPayload<any>) => {
      return this.userService.getAddressBooks({
        size: action.payload.current_page_size,
        page: action.payload.current_page,
        filter: action.payload.activeSearch
      }).map(data => {
        if (action.payload.activeSearch) {
          return new LoadFilteredAddressesSuccess({
            current_page_size: action.payload.current_page_size,
            current_page: action.payload.current_page,
            data: data.data,
            total: data.total,
            activeSearch: action.payload.activeSearch
          });
        }
        return new LoadAddressesSuccess({
          current_page_size: action.payload.current_page_size,
          current_page: action.payload.current_page,
          data: data.data,
          total: data.total
        });
      })
    });

  @Effect() setActiveAddressSearch = this.actions$
    .ofType(SET_ACTIVE_ADDRESS_SEARCH)
    .map((action: ActionWithPayload<any>) => {
      return new LoadAddresses({
        current_page_size: action.payload.current_page_size,
        current_page: action.payload.current_page,
        activeSearch: action.payload.activeSearch,
      })
    })
}



// WEBPACK FOOTER //
// ./src/app/store/effects/addresses.effect.ts